import { NotificationProvider } from './context';
import NotificationWeb from './NotificationWeb';

function Web() {
  return (
    <NotificationProvider>
      <NotificationWeb />
    </NotificationProvider>
  );
}

export default Web;
